import { useEffect, useState } from 'react'

// Owner toggles whether the Gemini call lets the model "think"
// (multi-step internal reasoning) before answering. Default off
// because the workout coach prompt is pattern-matching + a short
// suggestion — thinking adds 4-9s of latency and ~4x cost for
// marginal quality gain on that kind of task. Toggle is exposed
// in Settings so we can A/B it by hand without redeploying.
const KEY = 'phoenix.aiThinkingEnabled'

function read() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(KEY) === '1'
}

export function useAiThinkingEnabled() {
  const [enabled, setEnabledState] = useState(read)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const onStorage = (e) => {
      if (e.key === KEY) setEnabledState(e.newValue === '1')
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setEnabled = (next) => {
    if (typeof window === 'undefined') return
    if (next) window.localStorage.setItem(KEY, '1')
    else window.localStorage.removeItem(KEY)
    setEnabledState(!!next)
  }

  return [enabled, setEnabled]
}
